import React from 'react'
import PropTypes from 'prop-types'

const Quote = ({ input }) => (
  <blockquote className="blockquote">
      <p>{input.primary.text.text}</p>
  </blockquote>
)

export default Quote

Quote.propTypes = {
  input: PropTypes.object.isRequired,
}
